import React, { Component } from 'react';
import { connect } from 'react-redux';
import dateFormat from 'dateformat';
import {
  Box,
  Column,
  Row,
  Center,
  Expanded,
  Typography,
  Button,
  Alert,
  CircularProgress,
  InputSelectField,
  InputTextAreaField,
} from '@tempmee/react';
import { ListPageHeader } from '../commonComponents/ListPageHeader';
import { SendSMSModal } from '../commonComponents/SendSMSModal';
import { fetchAllSMS, sendSMS, sendSMSforPhones } from '../../actions/smsAction';
import { createLoadingSelector, createErrorMessageSelector } from '../../apis/selectors';
import { getAuthHeaders } from '../../actions/authActions';
import tempMee from '../../apis/tempMee';

const SMS_PROVIDER_OPTIONS = [
  { label: 'Twilio', value: 'twilio' },
  { label: 'TempMee', value: 'tempmee' },
  { label: 'Perminent Placement', value: 'pp' },
  { label: 'Opt-In Notifications & Alerts', value: 'notifications' },
];

if (!String.prototype.format) {
  String.prototype.format = function () {
    const args = arguments;
    return this.replace(/{(\d+)}/g, (match, number) =>
      typeof args[number] !== 'undefined' ? args[number] : match,
    );
  };
}

class SMSCampaign extends Component {
  constructor(props) {
    super(props);
    this.state = {
      smsType: 'twilio',
      templateBody:
        'Hey {0} - This is TempMee. (:\nDownload the app or learn more here https://tempmee.com/hygienist/',
      phoneNameBody:
        props?.location && props.location.state?.PhonesAndNamesParam
          ? props.location.state.PhonesAndNamesParam
          : '(XXX) XXX-XXXX, USER NAME\n(XXX) XXX-XXXX, USER NAME 2',
      phoneNumbersArray: [],
      smsBodyArray: [],
      errorTextConfirmAction: '',
      initialLoaderViewIsEnabled: false,
      errorText: '',
    };

    this.smsScroll = React.createRef();
  }

  componentWillMount() {
    const { location, history } = this.props;
    if (location.state) {
      if (history.location.state.job_id !== undefined) {
        this.setState({ initialLoaderViewIsEnabled: true });
        this.getUserInRadius();
      }
      if (location.state.report) {
        this.setState({ phoneNameBody: location.state.report });
      }
    }
  }

  componentDidUpdate() {
    const overflow = this.smsScroll.current;
    if (overflow) {
      overflow.scrollTo(0, overflow.scrollHeight);
    }
  }

  submitSMS = () => {
    const { templateBody, phoneNameBody, smsType } = this.state;
    const { fetchAllSMS } = this.props;
    const arrayPhoneNames = phoneNameBody
      .split('\n')
      .map((row) => row.split(',').map((text) => text.trim()))
      .filter((row) => row[0].length !== 0);
    const phones = arrayPhoneNames.map((pair) => pair[0]);
    const bodies = arrayPhoneNames.map((pair) => templateBody.format(...pair.slice(1)));
    this.setState({
      smsBodyArray: bodies,
      allSMSCount: phones.length,
      phoneNumbersArray: phones,
    });

    fetchAllSMS(phones[0], smsType);
  };

  // all sms by one click
  sumbitSMSforPhones = () => {
    const { sendSMSforPhones } = this.props;
    const { templateBody, phoneNameBody, smsType } = this.state;
    const arrayPhoneNames = phoneNameBody
      .split('\n')
      .map((row) => row.split(',').map((text) => text.trim()))
      .filter((row) => row[0].length !== 0);
    const lengthOfItems = arrayPhoneNames.map((pair) => pair.length);
    const isConsistent = lengthOfItems.every((v) => v === lengthOfItems[0]);
    if (!isConsistent) {
      this.setState({ errorText: 'Please, check inputs.They are not in correct format' });
      return;
    }
    sendSMSforPhones({ arrayPhoneNames, templateBody, textline: smsType });
  };

  prepareTextForCounts() {
    return `${this.state.allSMSCount - this.state.phoneNumbersArray.length + 1} / ${
      this.state.allSMSCount
    } `;
  }

  handlePhoneNameChange = (event) => {
    this.setState({ phoneNameBody: event.target.value });
  };

  getUserInRadius = async () => {
    try {
      const headers = await getAuthHeaders();
      const response = await tempMee.get(
        `/admin/jobs/${this.props.history.location.state.job_id}/radius`,
        {
          params: {
            maxRadius: this.props.history.location.state.maxRadiusValue,
            minRadius: this.props.history.location.state.minRadiusValue || 0,
          },
          headers,
        },
      );
      const arr = response.data.map((user) =>
        user.distance
          ? `${user.contact_number}, ${user.first_name}, ${user.distance?.toFixed(1)}`
          : `${user.contact_number}, ${user.first_name}`,
      );
      this.setState({ phoneNameBody: arr.join('\n') });
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ initialLoaderViewIsEnabled: false });
    }
  };

  handleTemplateChange = (event) => {
    this.setState({ templateBody: event.target.value });
  };

  callbackChangeText = (newText) => {
    const newArray = [newText, ...this.state.smsBodyArray.slice(1)];
    this.setState({ smsBodyArray: newArray });
  };

  confirmHasBeenClicked = async () => {
    const { phoneNumbersArray, smsBodyArray, smsType } = this.state;
    this.props.sendSMS({
      phone: phoneNumbersArray[0],
      body: smsBodyArray[0],
      textline: smsType,
    });
    this.skipHasBeenClicked();
  };

  skipHasBeenClicked = () => {
    const { fetchAllSMS } = this.props;
    const { phoneNumbersArray, smsBodyArray, smsType } = this.state;

    this.setState(
      {
        phoneNumbersArray: phoneNumbersArray.slice(1),
        smsBodyArray: smsBodyArray.slice(1),
        errorTextConfirmAction: '',
      },
      () => {
        if (this.state.phoneNumbersArray.length !== 0) {
          fetchAllSMS(this.state.phoneNumbersArray[0], smsType);
        }
      },
    );
  };

  cancelHasBeenClicked = () => {
    this.setState({
      phoneNumbersArray: [],
      smsBodyArray: [],
      errorTextConfirmAction: '',
    });
  };

  renderMessage() {
    const { reachable, allSMSforPhone } = this.props;

    const styleCellGray = {
      backgroundColor: reachable ? '#efefef' : 'red',
      textAlign: 'left',
      alignSelf: 'flex-start',
    };

    const styleCellBlue = {
      backgroundColor: reachable ? '#3EB0CA' : 'red',
      textAlign: 'right',
      alignSelf: 'flex-end',
    };

    return allSMSforPhone
      .sort((a, b) => a.created_at - b.created_at)
      .map((item) => {
        const date = dateFormat(new Date(item.created_at * 1000), 'ddd, mmmm dS, yyyy, h:MM:ss TT');

        const customStyle = item.creator.type === 'user' ? styleCellGray : styleCellBlue;
        return (
          <div
            style={{
              ...customStyle,
              marginBottom: 5,
              marginTop: 5,
              padding: 5,
              borderRadius: 5,
            }}
            key={item.uuid}
          >
            {item.body}
            <div style={{ fontSize: '12px', fontWeight: 'bold' }}>{date}</div>
          </div>
        );
      });
  }

  render() {
    const { customerNotes, smsCampaignAllowed, adminNotes, isLoading, allSMSforPhone } = this.props;
    const hasHistory = (allSMSforPhone || []).length > 0;
    if (this.state.initialLoaderViewIsEnabled) {
      return (
        <Center pt={8}>
          <CircularProgress size={32} />
        </Center>
      );
    }
    return (
      <Column align="center" gap={4} px={6} width="100%">
        <ListPageHeader title="SMS Campaign" />

        <Box width="300px">
          <InputSelectField
            value={this.state.smsType}
            onChange={(smsType) => this.setState({ smsType })}
            options={SMS_PROVIDER_OPTIONS}
          />
        </Box>

        <Row gap={4} width="100%" justify="center" align="stretch">
          <Expanded>
            <Column gap={2} width="100%">
              <Typography size="heading_4" bold textAlign="center">
                Template
              </Typography>
              <InputTextAreaField
                name="Text1"
                aria-label="Template"
                value={this.state.templateBody}
                onChange={this.handleTemplateChange}
                height={400}
              />
            </Column>
          </Expanded>
          <Expanded>
            <Column gap={2} width="100%">
              <Typography size="heading_4" bold textAlign="center">
                Phones and names
              </Typography>
              <InputTextAreaField
                name="Text2"
                aria-label="Phones and names"
                value={this.state.phoneNameBody}
                onChange={this.handlePhoneNameChange}
                height={400}
              />
            </Column>
          </Expanded>
        </Row>

        <Row gap={3} py={2}>
          <Button onClick={this.submitSMS}>Send SMS</Button>
          <Button onClick={this.sumbitSMSforPhones}>Send All</Button>
        </Row>

        {this.state.errorText && (
          <Typography className="text-error-500">{this.state.errorText}</Typography>
        )}
        <SendSMSModal
          smsPhone={this.state.phoneNumbersArray[0]}
          smsText={this.state.smsBodyArray[0]}
          customerNotesText={customerNotes}
          errorText={this.state.errorTextConfirmAction}
          showLoader={isLoading}
          adminNotes={adminNotes}
          countText={this.prepareTextForCounts()}
          onConfirm={this.confirmHasBeenClicked}
          onSkip={this.skipHasBeenClicked}
          onChangeText={this.callbackChangeText}
          onCancel={this.cancelHasBeenClicked}
          show={this.state.phoneNumbersArray.length !== 0}
        >
          <Typography size="body_large" bold textAlign="center">
            Previous messages:
          </Typography>
          {/* Cap the scroll region (max-h-96) so a long history scrolls here
              instead of stretching the modal past the viewport. With no history
              it collapses to a compact placeholder instead of reserving dead space. */}
          <Box ref={this.smsScroll} width="100%" px={4} py={2} className="overflow-y-auto max-h-96">
            {isLoading ? (
              <Center width="100%" py={4}>
                <CircularProgress size={32} />
              </Center>
            ) : hasHistory ? (
              <Column width="100%" gap={2}>
                {this.renderMessage()}
              </Column>
            ) : (
              <Center width="100%" py={2}>
                <Typography size="body_small" className="text-text-secondary">
                  No previous messages
                </Typography>
              </Center>
            )}
          </Box>
          {!smsCampaignAllowed ? (
            <Alert severity="error" description="User requested to not send them messages." />
          ) : null}
        </SendSMSModal>
      </Column>
    );
  }
}
const actions = ['GET_ALL_USER_SMS', 'SEND_SMS'];
const loadingSelector = createLoadingSelector(actions);
const errorSelector = createErrorMessageSelector(actions);
const mapStateToProps = (state) => ({
  isLoading: loadingSelector(state),
  error: errorSelector(state),
  customerNotes: state.sms.customerNotes,
  allSMSforPhone: state.sms.allSMSforPhone,
  reachable: state.sms.reachable,
  smsCampaignAllowed: state.sms.smsCampaignAllowed,
  adminNotes: state.sms.adminNotes,
});

export default connect(mapStateToProps, {
  fetchAllSMS,
  sendSMS,
  sendSMSforPhones,
})(SMSCampaign);
